import styled from '@emotion/styled';
import { r, rInset } from '../../../shared/lib/responsive';

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const Title = styled.h1`
  margin: 0;
  line-height: 1.3;
  letter-spacing: var(--letter-spacing-tight);
`;

export const TrophyWrap = styled.div`
  position: relative;
  ${r('width', 64)}
  ${r('height', 54)}
  ${r('margin-top', 23)}
`;

export const Trophy = styled.img`
  ${r('width', 55)}
  ${r('height', 54)}
  object-fit: contain;
  margin: 0 auto;
  display: block;
`;

export const Coin = styled.img`
  position: absolute;
  ${r('width', 9)}
  ${r('height', 9)}
  object-fit: contain;
`;

export const Coin1 = styled(Coin)`
  ${r('top', -2)}
  ${r('left', -4)}
`;

export const Coin2 = styled(Coin)`
  ${r('top', 6)}
  ${r('right', -4)}
  ${r('width', 7)}
  ${r('height', 7)}
`;

export const Coin3 = styled(Coin)`
  bottom: 0;
  ${r('left', 2)}
  ${r('width', 8)}
  ${r('height', 8)}
`;

export const Line1 = styled.span`
  display: block;
  font-family: var(--font-display);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-result-title-l1-size);
  color: var(--color-text-on-dark);
`;

export const Line2 = styled.span`
  display: block;
  font-family: var(--font-display);
  font-weight: var(--font-weight-regular);
  font-size: var(--type-result-title-l2-size);
  color: var(--color-gold);
`;

export const Stats = styled.p`
  display: inline-flex;
  align-items: center;
  gap: var(--reward-stats-gap);
  margin: 0;
`;

export const RateBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${r('min-width', 33)}
  ${rInset('padding', 2, 6)}
  border-radius: var(--radius-rate-badge);
  background: var(--color-rate-winner);
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-vote-rate-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
`;

export const Count = styled.span`
  font-family: var(--font-sans);
  font-weight: var(--font-weight-bold);
  font-size: var(--type-vote-count-winner-size);
  line-height: 1.2;
  letter-spacing: var(--letter-spacing-tight);
  color: var(--color-text-on-dark);
`;
